import {documentToReactComponents} from '@contentful/rich-text-react-renderer';
import React, {useMemo} from 'react';

import FooterNavigation from 'brandComponents/Footer/Subcomponents/FooterNavigation';
import Socials from 'brandComponents/Socials';

import CelebritiesHead from './Subcomponents/CelebritiesHead/CelebritiesHead';
import TextNewsletterPage from './Subcomponents/TextNewsletterPage/TextNewsletterPage';
import {options} from './config';
import {ITextProps} from './IText';

// eslint-disable-next-line no-restricted-imports
import './Text.scss';

// Wrap some components with a custom component
const kindsMap = {
	Socials: Socials,
	'Footer Navigation': FooterNavigation,
	'Newsletter Page': TextNewsletterPage,
	'Celebrities Head': CelebritiesHead,
};

const Text = ({kind, content, colorVariant, fontFamily, typography}: ITextProps) => {
	const attrsClassName: string = useMemo(() => {
		let attrsClassNameTemp = 'text';

		if (colorVariant) {
			attrsClassNameTemp += ` text__color-${colorVariant}`;
		}

		if (fontFamily) {
			attrsClassNameTemp += ` text__font-${fontFamily}`;
		}

		if (typography) {
			attrsClassNameTemp += ` text--${typography}`;
		}

		// Add the kind as a slugified className
		if (kind) {
			const kindSlugified = kind
				.toLowerCase()
				.trim()
				.replace(/[^\w\s-]/g, '')
				.replace(/[\s_-]+/g, '-')
				.replace(/^-+|-+$/g, '');

			attrsClassNameTemp += ` ${kindSlugified}`;
		}

		return attrsClassNameTemp;
	}, [kind, colorVariant, fontFamily]);

	// Get the kind of this element
	const WrapperComponent = useMemo(() => {
		if (typeof kindsMap[kind] === 'undefined') {
			return 'div';
		}

		return kindsMap[kind];
	}, [kind]);

	const contentToRender = useMemo(() => {
		const json = content?.props?.json || content?.json;
		let newJson = null;

		if (content?.links) {
			newJson = {
				content: json.content.map((contentItem) => {
					if (contentItem.nodeType === 'embedded-entry-block') {
						return {
							...contentItem,
							data: {
								...contentItem.data,
								target: content?.links?.entries?.block?.[0],
							},
						};
					}

					return contentItem;
				}),
			};
		}

		if (!json) {
			return null;
		}

		return documentToReactComponents(newJson ?? json, options);
	}, [content]);

	if (!contentToRender) {
		return null;
	}

	return (
		<WrapperComponent className={attrsClassName}>
			{contentToRender}
		</WrapperComponent>
	);
};

export default Text;
